export const getPrintCacheData = {
  1: 'cacheDataComercioDom',
  2: 'cacheDataComercioMS',
  3: 'cacheDataTalan'
};

export const newspaperIdGroup = [1,2,3];

export const configCalendarId = {
  1: {
    value: 'dateSelectedComercioD',
    groupId: 1,
    id: 1
  },
  2: {
    value: 'dateSelectedTalanD',
    groupId: 2,
    id:2
  },
  3: {
    value: 'dateSelectedComercioMS',
    groupId: 1,
    id: 3
  },
  4: {
    value: 'dateSelectedTalanS',
    groupId: 2,
    id: 4
  },
  5: {
    value: 'dateSelectedTalanLV',
    groupId: 2,
    id: 5
  },
  6: {
    value: 'dateSelectedDeporSD',
    groupId: 3,
    id: 6
  },
  7: {
    value: 'dateSelectedDeporLV',
    groupId: 3,
    id: 7
  }
};
